import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Login from './pages/Login';
// Admin views
import Profiles from './pages/admin/Profiles';
import ProfileCars from './pages/admin/ProfileCars';
import Profile from './pages/admin/Profile';
import Departments from './pages/admin/Departments';
import Department from './pages/admin/Department';
import Branches from './pages/admin/Branches';
import Branch from './pages/admin/Branch';
import Warehouses from './pages/admin/Warehouses';
import Warehouse from './pages/admin/Warehouse';
import GeneralConfig from './pages/admin/GeneralConfig';
import BulkVisitors from './pages/admin/BulkVisitors';
import MessagesConfig from './pages/admin/MessagesConfig';
import Levels from './pages/admin/Levels';
import Level from './pages/admin/Level';
import Cars from './pages/admin/Cars';
import Car from './pages/admin/Car';
import Jobs from './pages/admin/Jobs';
import Job from './pages/admin/Job';
import Plates from './pages/admin/Plates';
import Plate from './pages/admin/Plate';
import Services from './pages/admin/Services';
import Service from './pages/admin/Service';
import Transports from './pages/admin/Transports';
import Transport from './pages/admin/Transport';
import VisitCompanies from './pages/admin/VisitCompanies';
import VisitCompany from './pages/admin/VisitCompany';
import Visitors from './pages/admin/Visitors';
import Visitor from './pages/admin/Visitor';
import VisitTicketKinds from './pages/admin/VisitTicketKinds';
import TruckKinds from './pages/admin/TruckKinds';
import Trucks from './pages/admin/Trucks';
import Carriers from './pages/admin/Carriers';
import Drivers from './pages/admin/Drivers';
import VisitsBranch from './pages/visits/VisitsBranch';
import VisitsEmployee from './pages/visits/VisitsEmployee';
import VisitsForEmployee from './pages/visits/VisitsForEmployee';
import VisitsToday from './pages/visits/VisitsToday';
import VisitsInside from './pages/visits/VisitsInside';
import VisitsPending from './pages/visits/VisitsPending';
import VisitsAll from './pages/visits/VisitsAll';
import VisitsCarrier from './pages/visits/VisitsCarrier';
import Tags from './pages/admin/Tags';
// Guard
import Access from './pages/guard/Access';
// Support
import Tickets from './pages/public/Tickets';
import Ticket from './pages/public/Ticket';
import Chat from './pages/public/Chat';
import Videos from './pages/public/Videos';
import Video from './pages/public/Video';

import './App.css';

const App = () => (
  <Switch>
    <Route exact path="/" component={Login} />
    {/* Admin sections */}
    <Route exact path="/admin/users" component={Profiles} />
    <Route exact path="/admin/users/:id/cars" component={ProfileCars} />
    <Route exact path="/admin/users/:id" component={Profile} />
    <Route exact path="/admin/departments" component={Departments} />
    <Route exact path="/admin/departments/:id" component={Department} />
    <Route exact path="/admin/branches" component={Branches} />
    <Route exact path="/admin/branches/:id" component={Branch} />
    <Route exact path="/admin/warehouses" component={Warehouses} />
    <Route exact path="/admin/warehouses/:id" component={Warehouse} />
    <Route exact path="/admin/general-configuration" component={GeneralConfig} />
    <Route exact path="/admin/messages-configuration" component={MessagesConfig} />
    <Route exact path="/admin/levels" component={Levels} />
    <Route exact path="/admin/levels/:id" component={Level} />
    <Route exact path="/admin/cars" component={Cars} />
    <Route exact path="/admin/cars/:id" component={Car} />
    <Route exact path="/admin/jobs" component={Jobs} />
    <Route exact path="/admin/jobs/:id" component={Job} />
    <Route exact path="/admin/plates" component={Plates} />
    <Route exact path="/admin/plates/:id" component={Plate} />
    <Route exact path="/admin/services" component={Services} />
    <Route exact path="/admin/services/:id" component={Service} />
    <Route exact path="/admin/transports" component={Transports} />
    <Route exact path="/admin/transports/:id" component={Transport} />
    <Route exact path="/admin/visit_companies" component={VisitCompanies} />
    <Route exact path="/admin/visit_companies/:id" component={VisitCompany} />
    <Route exact path="/admin/visitors" component={Visitors} />
    <Route exact path="/admin/visitors/:id" component={Visitor} />
    <Route exact path="/admin/visit_ticket_kinds" component={VisitTicketKinds} />
    <Route exact path="/admin/truck_kinds" component={TruckKinds} />
    <Route exact path="/admin/trucks" component={Trucks} />
    <Route exact path="/admin/carriers" component={Carriers} />
    <Route exact path="/admin/drivers" component={Drivers} />
    <Route exact path="/admin/tags" component={Tags} />
    <Route exact path="/admin/bulk-visitors" component={BulkVisitors} />
    {/* Visits */}
    <Route exact path="/visits/branch" component={VisitsBranch} />
    <Route exact path="/visits/employee" component={VisitsEmployee} />
    <Route exact path="/visits-for-employee" component={VisitsForEmployee} />
    <Route exact path="/visits/today" component={VisitsToday} />
    <Route exact path="/visits/inside" component={VisitsInside} />
    <Route exact path="/visits/authorize" component={VisitsPending} />
    <Route exact path="/visits/all" component={VisitsAll} />
    <Route exact path="/visits/carrier" component={VisitsCarrier} />
    {/* Guard */}
    <Route exact path="/access" component={Access} />
    {/* Support */}
    <Route exact path="/support/chat" component={Chat} />
    <Route exact path="/support/tickets" component={Tickets} />
    <Route exact path="/support/tickets/:id" component={Ticket} />
    <Route exact path="/support/videos" component={Videos} />
    <Route exact path="/support/videos/:id" component={Video} />
  </Switch>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js